export class NumberFormatService {
  formatNumber(number, digits=2, locale = "de-DE") {
    if (typeof number === "string") {
      number = parseFloat(number.replace(/[^0-9.,]/g, "").replace(",", "."));
    }
    if (isNaN(number)) {
      return `0,${"0".repeat(digits)}`;
    }
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    }).format(number);
  }
}
